export default __webpack_public_path__ + "static/media/bunsBackground.b454bd15.jpg";